<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Oświadczenie</h2>
			</div>

			<v-container grid-list-md text-xs-center>
				<v-layout row wrap justify-center>

					<v-container fluid>
						<v-checkbox
							v-model="stepData.status1"
							data-vv-name="rodoCheckbox"
							data-vv-as="zgody przetwarzania danych osobowych"
							:true-value="true"
							:false-value="null"
							data-vv-scope="scope5"
							:error-messages="vErrors.collect('scope5.rodoCheckbox')"
							v-validate="'required'"
							aria-label="label for terms and conditions">
							<span slot="label" style="color: black;">
								Wyrażam zgodę na przetwarzanie przez Ministerstwo Spraw Zagranicznych moich danych zawartych w formularzu rejestracyjnym, dla potrzeb związanych z utworzeniem konta w aplikacji https://egranty.msz.gov.pl, zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016), w celu:								<ul>
									<li>rejestracji w bazie wolontariuszy,</li>
									<li>nawiązania ze mną kontaktu przez pracowników MSZ,</li>
									<li>udostępniania podmiotom zarejestrowanym w aplikacji określonych danych zawartych w formularzu rejestracyjnym, w tym danych pozwalających na nawiązanie ze mną kontaktu, w przypadku zamiaru zaproponowania mi uczestnictwa w projekcie wolontariackim. <span
										style="color: red">*</span></li>
								</ul>
							</span>
						</v-checkbox>
						<v-checkbox
							v-model="stepData.status2"
							data-vv-name="statusCheckbox"
							data-vv-as="zgody Regulaminu"
							:true-value="true"
							:false-value="null"
							:error-messages="vErrors.collect('scope5.statusCheckbox')"
							v-validate="'required'"
							data-vv-scope="scope5"
							aria-label="label for terms and conditions">
							<span slot="label" style="color: black;">
								Akceptuję treść <a target="_blank" rel="noopener noreferrer"
									:href="`${publicPath}eGranty - regulamin_aplikacji.pdf`" download>Regulaminu korzystania z portalu konkursowego</a> i oświadczam, że zapoznałem/am się z zawartą w nim informacją o przetwarzaniu moich danych osobowych. <span
										style="color: red">*</span>
							</span>
						</v-checkbox>
						<v-checkbox
							v-model="stepData.status3"
							data-vv-name="dataCheckbox"
							data-vv-as="zgody udostępniania danych"
							:true-value="true"
							:false-value="null"
							data-vv-scope="scope5"
							:error-messages="vErrors.collect('scope5.dataCheckbox')"
							v-validate="'required'"
							aria-label="label for terms and conditions">
							<span slot="label" style="color: black;">
								Zgadzam się na udostępnianie mojego imienia, nazwiska, poziomu wykształcenia, statusu aktywności zawodowej, znajomości języków obcych, preferowanych krajów odbywania wolontariatu zagranicznego oraz danych kontaktowych na liście osób zainteresowanych uczestnictwem w projektach, dostępnej dla podmiotów zarejestrowanych w aplikacji https://egranty.msz.gov.pl. <span
									style="color: red">*</span></span>
						</v-checkbox>
					</v-container>
				</v-layout>
			</v-container>
		</v-card>
		<v-btn color="blue"
			@click="$emit('step', 4)"
		>Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 6, 'scope5')">
			Rejestruj
		</v-btn>
	</div>
</template>

<script>
	export default {
		name: "StepTermsAndConditionsComponent",
		inject: ["parentValidator"],

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				publicPath: process.env.BASE_URL
			};
		},

		props: {
			stepData: Object,
		},

	};
</script>

<style scoped>

</style>
